import { render, staticRenderFns } from "./exitInterview.vue?vue&type=template&id=2bb7c22c&scoped=true&"
import script from "./exitInterview.vue?vue&type=script&lang=js&"
export * from "./exitInterview.vue?vue&type=script&lang=js&"
import style0 from "./exitInterview.vue?vue&type=style&index=0&id=2bb7c22c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb7c22c",
  null
  
)

export default component.exports